import React from 'react'
import { connect } from 'react-redux'
import { REDUCER, init, change } from 'ducks/password_recovery'
import Form from 'antd/lib/form'
import Icon from 'antd/lib/icon'
import Input from 'antd/lib/input'
import Button from 'antd/lib/button'

import { sprintf } from 'sprintf-js'
import l8n, { e } from 'l8n'

import { AuthPolicy } from 'components/CleanComponents/AuthPolicy/index'

const FormItem = Form.Item
const mapStateToProps = (state) => ({
  formSubmitted: state.app.submitForms[REDUCER],
  data: state.password_recovery.data,
  email: state.login.data.email.value
})

@connect(mapStateToProps)
@Form.create({
  onFieldsChange(props, changedFields) {
    props.dispatch(change(changedFields))
  },
  mapPropsToFields(props) {
    return {
      login: Form.createFormField({ ...props.data.login, value: !props.data.login.touched ? props.email : props.data.login.value }),
    }
  }
})
class PasswordRecoveryInitForm extends React.Component {
  onSubmit = (formSubmitted) => event => {
    event.preventDefault()
    const { form, dispatch } = this.props
    if (!formSubmitted) {
      form.validateFields((error, values) => {
        if (!error) {
          dispatch(init({ ...values, locale: l8n.locale }))
        }
      })
    }
  }

  render() {
    const { form, email, formSubmitted } = this.props
    return (
        <Form className="auth-form" hideRequiredMark onSubmit={this.onSubmit(formSubmitted)}>
          <FormItem hasFeedback label={l8n.p_email}>
            {form.getFieldDecorator('login', {
              rules: [
                { max: 100, message: e(sprintf(l8n.p_string_too_long, 100)) },
                { type: 'email', message: e(l8n.p_email_wrong) },
                { required: true, message: e(l8n.p_required) },
              ]
            })(
              <Input
                prefix={<Icon type="user" />}
                data-qa-id="password-recovery-email-input"
                placeholder={l8n.p_email}
              />
            )}
          </FormItem>
          <div className="form-actions">
            <Button type="primary" htmlType="submit" className="auth-form-button" data-qa-id="password-recovery-submit-button" loading={formSubmitted}>
              {l8n.p_recoverPassword}
            </Button>
          </div>
          <AuthPolicy/>
        </Form>
    )
  }
}

export default PasswordRecoveryInitForm



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Form/PasswordRecoveryForm/PasswordRecoveryInitForm/index.js